import produce from "immer"
import { ASC } from "const"
import { MtProjectGroup } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initProjectGroup: MtProjectGroup = {
    groupId: null,
    accountId: null,
    projectId: null,
    name: "",
    description: "",
    creator: null,
    default: false,
    order: 0,
}

const initProjectGroupState: types.ProjectGroupState = {
    groupList: {},
    groupIds: [],
    groupEdit: initProjectGroup,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const projectGroupReducer = produce((
    draft: types.ProjectGroupState = initProjectGroupState,
    action: ActionTypes = null,
): types.ProjectGroupState => {
    switch (action.type) {
        case types.PROJECT_GROUP_LIST:
            draft.groupList = action.groupList
            return draft

        case types.PROJECT_GROUP_IDS:
            draft.groupIds = action.groupIds
            return draft

        case types.PROJECT_GROUP_EDIT:
            draft.groupEdit = action.group
            return draft

        case types.PROJECT_GROUP_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.PROJECT_GROUP_FILTERS:
            draft.filters = action.filters
            return draft

        case types.PROJECT_GROUP_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.PROJECT_GROUP_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default projectGroupReducer
